// Resume41.js
import React from 'react';

const Resume41 = ({ color = "#5d4037" }) => {   // default to Warm Brown if no prop passed

  return (
    <div
      style={{
        width: '210mm',
        minHeight: '297mm',
        backgroundColor: '#fdfaf5',           // very light cream/beige
        color: '#2e2e2e',
        fontFamily: 'Arial, Helvetica, sans-serif',
        display: 'flex',
        margin: '0 auto',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        overflow: 'hidden',
      }}
    >
      {/* LEFT COLUMN - Photo + Contact + Skills + Awards */}
      <div
        style={{
          width: '38%',
          backgroundColor: '#f3ede5',         // soft beige
          padding: '60px 40px',
          display: 'flex',
          flexDirection: 'column',
          gap: '50px'
        }}
      >
        {/* Circular Photo */}
        <div style={{ alignSelf: 'center' }}>
          <img
            src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=987&q=80"
            alt="Ndememi Otieno"
            style={{
              width: '190px',
              height: '190px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: `12px solid ${color}`,
              boxShadow: '0 6px 16px rgba(0,0,0,0.1)'
            }}
          />
        </div>

        {/* CONTACT */}
        <div>
          <h3
            style={{
              fontSize: '1.35rem',
              fontWeight: 'bold',
              marginBottom: '20px',
              color: color,
              textTransform: 'uppercase',
              letterSpacing: '1.4px'
            }}
          >
            CONTACT
          </h3>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              fontSize: '0.98rem',
              lineHeight: '1.8',
              color: '#444'
            }}
          >
            <li>• hello@reallygreatsite.com</li>
            <li>• +123-456-7890</li>
            <li>• www.reallygreatsite.com</li>
          </ul>
        </div>

        {/* SKILLS */}
        <div>
          <h3
            style={{
              fontSize: '1.35rem',
              fontWeight: 'bold',
              marginBottom: '20px',
              color: color,
              textTransform: 'uppercase',
              letterSpacing: '1.4px'
            }}
          >
            SKILLS
          </h3>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              fontSize: '0.98rem',
              lineHeight: '1.8',
              color: '#444'
            }}
          >
            <li>• Project Management</li>
            <li>• Software Development</li>
            <li>• Budgeting and Cost Analysis</li>
            <li>• Program Development Analysis</li>
            <li>• Public Speaking & Presentations</li>
            <li>• Strategic Planning & Visioning</li>
            <li>• Process Improvement</li>
          </ul>
        </div>

        {/* AWARDS */}
        <div>
          <h3
            style={{
              fontSize: '1.35rem',
              fontWeight: 'bold',
              marginBottom: '20px',
              color: color,
              textTransform: 'uppercase',
              letterSpacing: '1.4px'
            }}
          >
            AWARDS
          </h3>
          <ul
            style={{
              listStyle: 'none',
              padding: 0,
              margin: 0,
              fontSize: '0.98rem',
              lineHeight: '1.7',
              color: '#444'
            }}
          >
            <li>• Most Outstanding Employee of the Year (2015)</li>
            <li>• Best Mobile App Design (2014)</li>
          </ul>
        </div>
      </div>

      {/* RIGHT COLUMN - Name + Summary + Education + Experience */}
      <div
        style={{
          width: '62%',
          padding: '60px 50px',
          backgroundColor: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          gap: '45px'
        }}
      >
        {/* Name & Title & Summary */}
        <div>
          <h1
            style={{
              fontSize: '2.9rem',
              fontWeight: 'bold',
              margin: '0 0 10px 0',
              color: '#3a2f27',
              lineHeight: '1.05'
            }}
          >
            NDEMEMI<br />OTIENENO
          </h1>
          <h2
            style={{
              fontSize: '1.55rem',
              fontWeight: '600',
              margin: '0 0 28px 0',
              color: color
            }}
          >
            IT PROJECT MANAGER
          </h2>

          <p
            style={{
              fontSize: '1.02rem',
              lineHeight: '1.7',
              color: '#555',
              margin: 0
            }}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc tincidunt ut quam eget, luctus sollicitudin neque. Sed leo nisl, semper ac hendrerit a, sollicitudin in arcu.
          </p>
        </div>

        {/* Horizontal Divider */}
        <hr
          style={{
            border: 'none',
            borderTop: '2px solid #e0d0bf',
            margin: '20px 0 30px 0'
          }}
        />

        {/* EDUCATION */}
        <div>
          <h2
            style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              marginBottom: '24px',
              color: color,
              textTransform: 'uppercase',
              letterSpacing: '1.3px'
            }}
          >
            EDUCATION
          </h2>

          <div style={{ marginBottom: '32px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
              <div style={{ fontSize: '1.8rem', color: color, lineHeight: '1' }}>○</div>
              <div>
                <strong style={{ fontSize: '1.15rem' }}>Wardriere University</strong><br />
                <span style={{ color: '#666', fontSize: '0.97rem' }}>
                  (2019 - 2024) • 3.7/4 GPA
                </span><br />
                <span>Master of Business Management</span>
              </div>
            </div>
          </div>

          <div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
              <div style={{ fontSize: '1.8rem', color: color, lineHeight: '1' }}>○</div>
              <div>
                <strong style={{ fontSize: '1.15rem' }}>Rimberio University</strong><br />
                <span style={{ color: '#666', fontSize: '0.97rem' }}>
                  (2024 - 2028) • 3.9/4 GPA
                </span><br />
                <span>Bachelor of Business Management</span>
              </div>
            </div>
          </div>
        </div>

        {/* EXPERIENCE */}
        <div>
          <h2
            style={{
              fontSize: '1.5rem',
              fontWeight: 'bold',
              marginBottom: '24px',
              color: color,
              textTransform: 'uppercase',
              letterSpacing: '1.3px'
            }}
          >
            EXPERIENCE
          </h2>

          <div style={{ marginBottom: '36px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
              <div style={{ fontSize: '1.8rem', color: color, lineHeight: '1' }}>○</div>
              <div>
                <strong style={{ fontSize: '1.15rem' }}>Ingoude Company | Project Manager</strong><br />
                <span style={{ color: '#666', fontSize: '0.97rem' }}>January 2019 – June 2020</span><br /><br />
                <p style={{ margin: '8px 0 0 0', lineHeight: '1.65' }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc ullamcorper orci non ornare vehicula...
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '36px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
              <div style={{ fontSize: '1.8rem', color: color, lineHeight: '1' }}>○</div>
              <div>
                <strong style={{ fontSize: '1.15rem' }}>Giggling Platypus Co. | Art Director</strong><br />
                <span style={{ color: '#666', fontSize: '0.97rem' }}>June 2020 – February 2022</span><br /><br />
                <p style={{ margin: '8px 0 0 0', lineHeight: '1.65' }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit...
                </p>
              </div>
            </div>
          </div>

          <div>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}>
              <div style={{ fontSize: '1.8rem', color: color, lineHeight: '1' }}>○</div>
              <div>
                <strong style={{ fontSize: '1.15rem' }}>Wardriere Inc. | Senior UX Designer</strong><br />
                <span style={{ color: '#666', fontSize: '0.97rem' }}>February 2022 – September 2024</span><br /><br />
                <p style={{ margin: '8px 0 0 0', lineHeight: '1.65' }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit...
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
  colorOptions: [
    { value: "#e35cc4", label: "Vivid Pink" },
    { value: "#00695c", label: "Deep Teal" },
    { value: "#d84315", label: "Fiery Orange" },
    { value: "#5d4037", label: "Warm Brown" },
    { value: "#0277bd", label: "Strong Blue" }
  ]
};

export default Resume41;